import React, { FC } from 'react';

import { navigate } from '@reach/router';

import AddPlayersCard from '../../../../components/AddPlayersCard';
import Button from '../../../../components/Button';

const AddPlayersToClub: FC = () => {
  const onSkip = () => {
    return navigate(`/admin/events`);
  };

  return (
    <div className="home wrapper add-players-club-wrapper">
      <div>
        <div className="add-players-main-container">
          <h1>
            FIRST THINGS FIRST. <br />
            LET’S ADD SOME PLAYERS TO YOUR CLUB
          </h1>

          <div className="cards-container">
            <AddPlayersCard />
          </div>

          <Button onClick={onSkip} variant="text" color="primary" className="button skip-button">
            SKIP FOR NOW
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddPlayersToClub;
